import { useEffect } from "react";

// react-router components
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";

// Material Dashboard 2 React themes
import theme from "assets/theme";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";

// Material Dashboard 2 React contexts
import { useMaterialUIController, setSideBarVisibility } from "context";

// Images
import logo from "assets/images/vct_technologies_logo.png";
import HomePage from "layouts/landing/home";
import RequestDataDelete from "layouts/landing/components/RequestDataDelete";
import TermsOfUse from "layouts/landing/termsOfUse";
import PrivacyPolicy from "layouts/landing/privacyPolicy";
import { useDispatch, useSelector } from "react-redux";
import { PersistLoggedInUser, IsAuthenticated } from "./helpers";
import {
  unauthenticatedRoutes,
  customerRoutes,
  rmRoutes,
  adminRoutes,
  supportRoutes,
  techRoutes,
} from "routes";
import "devextreme/dist/css/dx.light.css";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { user_data } = useSelector((state) => state.authentication);

  let routes = customerRoutes;

  const { direction, layout, sidenavColor, darkMode } = controller;
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // Authentication Check
  useEffect(() => {
    const tokenValidity = localStorage.getItem("token_validity");
    const TokenDate = new Date(tokenValidity);
    const NewDate = new Date();
    if (tokenValidity != null && TokenDate <= NewDate) {
      localStorage.clear();
      navigate("/");
      // console.log(tokenValidity);
    }
  }, []);
  //Hiding the sidebar when navigate to the home page

  const dispatchData = useDispatch();
  useEffect(() => {
    setSideBarVisibility(dispatch, false);
    PersistLoggedInUser(dispatchData);
  }, []);

  if (user_data?.customer?.roleId == 2) {
    routes = rmRoutes;
  } else if (user_data?.customer?.roleId == 3) {
    routes = supportRoutes;
  } else if (user_data?.customer?.roleId == 4) {
    routes = adminRoutes;
  } else if (user_data?.customer?.roleId == 5) {
    routes = techRoutes;
  } else {
    routes = customerRoutes;
  }

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  const url = window.location.pathname;
  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />

      {url !== "/authentication/sign-in"
        ? layout === "dashboard" && (
            <Sidenav
              color={sidenavColor}
              brand={logo}
              brandName="VCT Technologies LLC"
              routes={IsAuthenticated ? routes : unauthenticatedRoutes}
              onMouseEnter={() => {}}
              onMouseLeave={() => {}}
            />
          )
        : ""}
      {/* {layout === "vr" && <Configurator />} */}

      {!IsAuthenticated() ? (
        <Routes>
          {getRoutes(unauthenticatedRoutes)}
          <Route path="*" element={<HomePage />} key="home" />
          <Route path="/termsofuse" element={<TermsOfUse />} key="termsofuse" />
          <Route
            path="/privacypolicy"
            element={<PrivacyPolicy />}
            key="privacypolicy"
          />
          <Route
            path="/request-data-delete"
            element={<RequestDataDelete />}
            key="request-data-delete"
          />
          RequestDataDelete
        </Routes>
      ) : (
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<HomePage />} key="home" />
          <Route path="/termsofuse" element={<TermsOfUse />} key="termsofuse" />
          <Route
            path="/privacypolicy"
            element={<PrivacyPolicy />}
            key="privacypolicy"
          />
          <Route
            path="/request-data-delete"
            element={<RequestDataDelete />}
            key="request-data-delete"
          />
        </Routes>
      )}
    </ThemeProvider>
  );
}
